export default "__VITE_ASSET__a76xZY95__"